export default __webpack_public_path__ + "static/media/not-ignition-on.4c542bbd.svg";